import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { EN_SUPPORTED_PATHS, withLang, stripLangPrefix } from '../utils/routes';

/**
 * Mount this once inside <BrowserRouter>.
 * - If lang === "en" and the current path is a Swedish path → redirect to /en version.
 * - If lang === "sv" and the current path starts with /en → redirect to Swedish version.
 * Only redirects to paths that exist in EN_SUPPORTED_PATHS.
 */
const LangRedirect = () => {
  const { currentLang } = useLanguage();
  const navigate        = useNavigate();
  const location        = useLocation();

  useEffect(() => {
    const path     = location.pathname;
    const isEnPath = path === '/en' || path.startsWith('/en/');

    if (currentLang === 'en' && !isEnPath) {
      // Only redirect if the page has an English version
      if (EN_SUPPORTED_PATHS.has(path)) {
        navigate(withLang(path, 'en'), { replace: true });
      }
      return;
    }

    if (currentLang === 'sv' && isEnPath) {
      const svPath = stripLangPrefix(path);
      navigate(svPath, { replace: true });
    }
  }, [currentLang, location.pathname]); // re-run when lang or path changes

  return null;
};

export default LangRedirect;
